import { PlaybookType } from "../models/PlaybookType";

export class PlaybookShort {
  public id: string;
  public title: string;
  public description?: string;
  public isFavorite: boolean;
  public type: PlaybookType;

  public constructor(data: any) {
    this.id = data.id;
    this.title = data.title;
    this.description = data.description;
    this.isFavorite = data.isFavorite;
    this.type = data.type as PlaybookType;
  }
}

export class Playbook extends PlaybookShort {
  public steps: PlaybookStep[];

  public constructor(data: any) {
    super(data);
    this.steps = data.steps.map((step: any) => new PlaybookStep(step));
    this.description = data.description;
  }
}

export class PlaybookStep {
  public id: string;
  public title: string;
  public prompt: string;

  public constructor(data: any) {
    this.id = data.id;
    this.title = data.title;
    this.prompt = data.prompt;
  }
}
